var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "h3",
        { staticClass: "popover-title" },
        [
          _vm.selectedOrderId
            ? _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "NUMBER_ORDER",
                    expression: "'NUMBER_ORDER'"
                  }
                ]
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.selectedOrderId
            ? _c(
                "dropdown",
                {
                  staticClass: "bulk-actions-dropdown",
                  attrs: { tag: "span", "menu-right": false }
                },
                [
                  _c(
                    "btn",
                    { attrs: { size: "sm", "data-cy": "order-time-options" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t(_vm.selectedTimeOption.text)) +
                          "\n        "
                      ),
                      _c("span", { staticClass: "caret" })
                    ]
                  ),
                  _vm._v(" "),
                  _c("template", { slot: "dropdown" }, [
                    _c(
                      "li",
                      _vm._l(_vm.timeOptions, function(timeOption) {
                        return _c("a", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: timeOption.text,
                              expression: "timeOption.text"
                            }
                          ],
                          key: timeOption.id,
                          staticClass: "btn bulk-actions-dropdown__btn",
                          attrs: { "data-cy": "order-time-option" },
                          on: {
                            click: function($event) {
                              return _vm.onSelectedTimeOption(timeOption)
                            }
                          }
                        })
                      }),
                      0
                    )
                  ])
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "close",
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.closeModal.apply(null, arguments)
                }
              }
            },
            [
              _c("i", {
                staticClass: "typcn typcn-delete",
                attrs: { "aria-hidden": "true" }
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.selectedOrderId
        ? _c("NumberOrderList", {
            attrs: {
              orders: _vm.orders,
              status: _vm.getOrdersStatus,
              timezone: _vm.accountTranslatedTimeZoneId
            },
            on: { selected: _vm.orderSelected }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedOrderId
        ? _c("NumberOrder", {
            attrs: {
              order: _vm.selectedOrder,
              status: _vm.getSelectedOrderStatus,
              timezone: _vm.accountTranslatedTimeZoneId
            },
            on: { back: _vm.onBack, cancelOrder: _vm.onCancelOrder }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }